import * as React from "react"
import type { SVGProps } from "react"
const SvgTrendingDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m18.6 16-5.2-5.15-2.58 2.58q-.57.57-1.42.57t-1.43-.57L2.7 8.1a1 1 0 0 1-.29-.69q0-.4.29-.71a1 1 0 0 1 .7-.27q.42 0 .7.27L9.4 12l2.57-2.57q.58-.58 1.43-.58t1.42.58L20 14.6V13q0-.42.29-.71.29-.3.71-.29.42 0 .71.29.3.29.29.71v4q0 .42-.29.71-.29.3-.71.29h-4a1 1 0 0 1-.71-.29A1 1 0 0 1 16 17q0-.42.29-.71.29-.3.71-.29z" />
  </svg>
)
export default SvgTrendingDown
